var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWidgetText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6823 15.3254H28.2744C23.8396 15.3254 20.2281 11.7139 20.2281 7.27911V1.87124C20.2281 0.842056 19.386 0 18.3568 0H10.4228C4.65938 0 0 3.74247 0 10.4228V27.0019C0 33.6823 4.65938 37.4247 10.4228 37.4247H25.1307C30.8941 37.4247 35.5535 33.6823 35.5535 27.0019V17.1967C35.5535 16.1675 34.7114 15.3254 33.6823 15.3254Z",
    fill: "#39D3B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8868 0.392851C24.1196 -0.374356 22.791 0.14959 22.791 1.21619V7.74681C22.791 10.4788 25.1114 12.743 27.9369 12.743C29.7146 12.7617 32.1846 12.7617 34.2991 12.7617C35.3657 12.7617 35.9271 11.508 35.1786 10.7595C32.484 8.04621 27.6562 3.16228 24.8868 0.392851Z",
    fill: "#733FD7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.584 21.987H9.35655C8.58935 21.987 7.95312 21.3508 7.95312 20.5836C7.95312 19.8164 8.58935 19.1801 9.35655 19.1801H20.584C21.3512 19.1801 21.9874 19.8164 21.9874 20.5836C21.9874 21.3508 21.3512 21.987 20.584 21.987Z",
    fill: "#733FD7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8415 29.472H9.35655C8.58935 29.472 7.95312 28.8357 7.95312 28.0685C7.95312 27.3013 8.58935 26.6651 9.35655 26.6651H16.8415C17.6087 26.6651 18.2449 27.3013 18.2449 28.0685C18.2449 28.8357 17.6087 29.472 16.8415 29.472Z",
    fill: "#733FD7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4052 24.029L44.7669 25.1346C44.5466 25.5162 44.0587 25.6469 43.6771 25.4266L36.8919 21.5092C36.5103 21.2889 36.3796 20.8009 36.5999 20.4193L37.2382 19.3138C38.5307 17.0751 41.4297 16.2983 43.6822 17.5988C45.9209 18.8913 46.6977 21.7904 45.4052 24.029Z",
    fill: "#733FD7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9457 37.1407C26.5866 37.7625 26.2987 38.8676 26.3272 39.5842L26.3615 42.1099C26.4137 45.0512 28.5418 46.2799 31.1014 44.8465L33.3196 43.6213C33.9406 43.2797 34.7537 42.4778 35.1127 41.8559L42.8199 28.5067C43.0402 28.1251 42.9095 27.6372 42.5279 27.4169L35.7427 23.4994C35.3611 23.2791 34.8732 23.4099 34.6528 23.7915L26.9457 37.1407Z",
    fill: "#733FD7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetText);
export default __webpack_public_path__ + "static/media/WIDGET_TEXT.6b2e8fa3a407843720a5928a198e0c92.svg";
export { ForwardRef as ReactComponent };